import { useQuery } from "@tanstack/react-query";
import { getSupabaseClient } from "../providers/supabase/supabase";

export type AgentActivityRun = {
  id: string;
  agent_name: string;
  run_type: string;
  status: string;
  trigger_type: string | null;
  actor_called: string | null;
  target_contact_id: number | null;
  target_company_id: number | null;
  created_at: string;
  completed_at: string | null;
};

/**
 * PRD Screen 5 — "Recent mentorax.agent_runs rows scoped to outreach-list
 * actions... with a link into the affected list/contact." Scoped to runs
 * that actually target a contact or company (excludes untargeted batch/sweep
 * runs like Marco's cron sweeps, which have no specific lead to link to).
 *
 * mentorax.agent_runs is unreachable through the public-scoped react-admin
 * data provider — same direct-schema-query pattern as the outreach timeline
 * and Marco activity feed.
 */
export function useAgentActivity() {
  return useQuery({
    queryKey: ["agent-activity"],
    queryFn: async (): Promise<AgentActivityRun[]> => {
      const { data, error } = await getSupabaseClient()
        .schema("mentorax")
        .from("agent_runs")
        .select(
          "id, agent_name, run_type, status, trigger_type, actor_called, target_contact_id, target_company_id, created_at, completed_at",
        )
        .or("target_contact_id.not.is.null,target_company_id.not.is.null")
        .order("created_at", { ascending: false })
        .limit(100);
      if (error) throw error;
      return (data ?? []) as AgentActivityRun[];
    },
  });
}
